import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import WarehouseUsagePage from "./ui/WarehouseUsagePage";

/** Warehouse cost panel, query history and verified queries — workspace admins. */
const WarehouseUsage = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <WarehouseUsagePage />
    </PageContentShell>
  </DashboardLayout>
);

export default WarehouseUsage;
